const { Component } = Shopware;
const utils = Shopware.Utils;

Component.extend('acris-faq-create', 'acris-faq-detail', {
    beforeRouteEnter(to, from, next) {
        if (to.name.includes('acris.faq.create') && !to.params.id) {
            to.params.id = utils.createId();
            to.params.newItem = true;
        }

        next();
    },

    created() {
        this.createdComponent();
        this.getCategoriesCollection();
    },

    methods: {
        getEntity() {
            this.item = this.faqRepository.create(Shopware.Context.api);
            this.item.active = true;
            this.item.imagePosition = 'right';
            this.item.videoPosition = 'right';
            this.item.imageUrlTarget = '_blank';
            this.item.imageSize = 'large';
            this.item.videoType = 'youtube';
            this.item.collapsed = 'isCollapsed';
            this.item.imageUrlType = 'external';
            this.item.imageUrlEntity = 'category';
            this.item.layout = 'default';
            this.item.metaDataOption = 'show';
        },

        createdComponent() {
            if (!Shopware.Store.get('context').isSystemDefaultLanguage) {
                Shopware.Store.get('context').resetLanguageToDefault();
            }

            this.$super('createdComponent');
        },

        saveFinish() {
            this.isSaveSuccessful = false;
            this.$router.push({ name: 'acris.faq.detail', params: { id: this.item.id } });
        },

        getCategoriesCollection() {
            this.$super('getCategoriesCollection');
        },

        onClickSave() {
            this.isLoading = true;
            const titleSaveError = this.$tc('acris-faq.detail.titleSaveError');
            const messageSaveError = this.$tc('acris-faq.detail.messageSaveError');
            const titleSaveSuccess = this.$tc('acris-faq.detail.titleSaveSuccess');
            const messageSaveSuccess = this.$tc('acris-faq.detail.messageSaveSuccess');

            this.faqRepository
                .save(this.item, Shopware.Context.api)
                .then(() => {
                    this.isLoading = false;
                    this.createNotificationSuccess({
                        title: titleSaveSuccess,
                        message: messageSaveSuccess
                    });
                    this.$router.push({ name: 'acris.faq.detail', params: { id: this.item.id } });
                })
                .catch(() => {
                    this.isLoading = false;
                    this.createNotificationError({
                        title: titleSaveError,
                        message: messageSaveError
                    });
                });
        }
    }
});
